import heroImage from "../../assets/illustration.svg";
import iconBulb from "../../assets/iconBulb.png";
import iconPuzzle from "../../assets/iconPuzzle.png";
import iconRocket from "../../assets/iconRocket.png";
import skilledIcon from "../../assets/skilledIcon.png";

import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
 <section className="font-poppins bg-[#f8f9fb] px-4 md:px-8 lg:px-16 py-10 md:py-10 min-h-[70vh] overflow-hidden relative">
      <div className="max-w-[1440px] mx-auto flex flex-col md:flex-row items-center justify-between gap-12">
        <div className="w-full md:w-[60%] text-left mb-8 md:mb-0">
          <div className="mb-4 md:mb-6 xl-mb-10">
            <p className="text-[#07862B] text-[16px] md:text-[20px] font-medium mb-4 md:mb-5 xl:mb-8 leading-tight">
              Solutions for your business
            </p>

            <h1 className="text-[#212129] text-[24px] md:text-[32px] xl:text-[48px] font-medium leading-tight mb-4 md:mb-5 lg:mb-8">
              IT consulting with{" "}
              <br className="hidden md:block" />
              professionalism &amp; integrity
            </h1>

            <div
              className="w-[15%] border border-[#07862B] mb-4 md:mb-5 xl:mb-8"
              aria-hidden="true"
            />

          <p className="text-[#212129] text-sm md:text-[16px] leading-normal font-regular">
  We manages professionalism in the IT industry by providing <br />
  top-quality consulting and related services.
</p>
          </div>

          <div className="flex gap-7 justify-center lg:justify-start">
            <Link to="/Contact#contact-section">
              <button
                type="button"
                className="bg-[#07862B] text-white px-6 py-3 xl:px-10 xl:py-4 rounded-xl text-sm md:text-[16px] font-semibold"
              >
                <span>Get a Quote</span>
              </button>
            </Link>

          <Link to="/company/our-advantages/">
  <button
    type="button"
    className="border border-[#07862B] text-[#07862B] px-6 py-3 xl:px-10 xl:py-4 rounded-xl text-sm md:text-[16px] font-semibold"
  >
    <span>Learn more</span>
  </button>
</Link>
          </div>
        </div>

        <div className="w-full md:w-[40%] relative max-w-[600px] mx-auto lg:mx-0">
          <img
            src={heroImage}
            alt="IT consulting team illustration"
            className="w-full h-auto relative z-10 object-contain"
          />

          <motion.div
            initial={{ y: -8 }}
            animate={{ y: 0 }}
            transition={{ repeat: Infinity, duration: 2, repeatType: "reverse" }}
            className="absolute top-[-8%] right-[12%] md:top-[-10%] md:right-[14%] xl:top-[-5%] xl:right-[10%] bg-white rounded-full p-2 md:p-3 shadow-md z-20"
            aria-hidden="true"
          >
            <img
              src={iconBulb}
              alt="Idea icon"
              className="w-3 lg:w-5 h-3 lg:h-5"
            />
          </motion.div>

          <motion.div
            initial={{ y: -10 }}
            animate={{ y: 0 }}
            transition={{ repeat: Infinity, duration: 2.3, repeatType: "reverse" }}
            className="absolute top-[-3%] right-[27%] md:right-[29%] md:top-[-3%] xl:top-[-4%] xl:right-[27%] bg-white rounded-full p-2 md:p-3 shadow-md z-20"
            aria-hidden="true"
          >
            <img
              src={iconPuzzle}
              alt="Problem solving icon"
              className="w-6 lg:w-8 h-6 lg:h-8"
            />
          </motion.div>

          <motion.div
            initial={{ y: -10 }}
            animate={{ y: 0 }}
            transition={{ repeat: Infinity, duration: 2.8, repeatType: "reverse" }}
            className="absolute top-[8%] md:right-[12%] xl:top-[8%] xl:right-[15%] bg-white rounded-full p-2 md:p-3 shadow-md z-20"
            aria-hidden="true"
          >
            <img
              src={iconRocket}
              alt="Growth rocket icon"
              className="w-4 lg:w-6 h-4 lg:h-6"
            />
          </motion.div>

          <motion.div
            initial={{ x: -10 }}
            animate={{ x: 0 }}
            transition={{ repeat: Infinity, duration: 3, repeatType: "reverse" }}
            className="absolute bottom-[20px] left-[30px] sm:bottom-[40px] sm:left-[-20px] md:left-[-10px] bg-white rounded-[30px] shadow-lg px-4 md:px-5 py-2 md:py-3 flex items-center gap-2 md:gap-3 z-20"
            aria-hidden="true"
          >
            <img
              src={skilledIcon}
              alt="Skilled professionals icon"
              className="w-[24px] md:w-[28px] h-[24px] md:h-[28px]"
            />
            <div className="text-[#222] text-[12px] md:text-[14px] font-regular leading-tight">
              Skilled <br /> professionals
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
